<template>
    <v-dialog v-model="cargar" :fullscreen="$root.isTouch" :scrollable="$root.isTouch == false" max-width="60%" persistent>
        <v-card>
            <v-card-title class="bg-title-card">
                <span class="white--text headline" v-html="tituloFormulario"></span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="form">
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field label="Nombre Condición *" color="textbox"
                                    v-model="objetoCondicion.nombreCondicion"
                                    :rules="_.concat(requeridoRegla,soloLetrasRegla(4,objetoCondicion.nombreCondicion,300))"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete label="Aseguradora *" color="textbox"
                                    v-model="objetoCondicion.idAseguradora" :rules="requeridoRegla"
                                    :items="lista.aseguradora" item-text="aseguradora" item-value="idAseguradora"
                                    outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col v-bind:style="{ width: ancho }">
                                <v-autocomplete label="Tipo Condición *" color="textbox"
                                    v-model="objetoCondicion.idTipoCondicion" :rules="requeridoRegla"
                                    :items="lista.tipoCondicion" item-text="tipoCondicion" item-value="idTipoCondicion"
                                    @change="cambiarTam(), visibilidadCheckBOx()" outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-autocomplete color="textbox"
                                    v-if="(objetoCondicion.idTipoCondicion==lista.idLlevaCobertura) && (objetoCondicion.idTipoCondicion!=null)"
                                    label="Cobertura *" v-model="objetoCondicion.idCobertura" :rules="requeridoRegla"
                                    :items="lista.cobertura" item-text="cobertura" item-value="idCobertura" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col v-bind:style="{ width: anchoSeguro }">
                                <v-autocomplete color="textbox" v-model="objetoCondicion.idSeguro"
                                    :rules="requeridoRegla" :items="lista.seguro" item-text="seguro"
                                    item-value="idSeguro" label="Seguro" @change="visibilidadCheckBOx()" outlined dense>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="checkBoxV">
                                <v-checkbox color="textbox" label="Vehículo con Crédito *" dense
                                    v-model="objetoCondicion.vehiculoCredito"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-text-field color="textbox" label="Número Registro SCVS *"
                                    v-model="objetoCondicion.numeroRegistroSCVS"
                                    :rules="_.concat(requeridoRegla,soloNumerosRegla(4,objetoCondicion.numeroRegistroSCVS,10))"
                                    outlined dense />
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-dialog ref="dialog" v-model="objDate.abrirDialogo"
                                    :return-value.sync="objetoCondicion.fechaRegistroSCVS" persistent width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field color="textbox" v-model="objetoCondicion.fechaRegistroSCVS"
                                            label="Fecha Registro SCVS *" :rules="requeridoRegla"
                                            prepend-inner-icon="event" readonly outlined dense v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="objetoCondicion.fechaRegistroSCVS" color="primary" scrollable locale="es">
                                        <v-spacer></v-spacer>
                                        <v-btn color="secundary" rounded @click="objDate.abrirDialogo = false" v-html="'Salir'"></v-btn>
                                        <v-btn color="primary" rounded @click="$refs.dialog.save(objetoCondicion.fechaRegistroSCVS)" v-html="'Guardar Fecha'"></v-btn>
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6">
                                <v-autocomplete color="textbox" label="Estado" v-model="objetoCondicion.idEstado"
                                    :rules="requeridoRegla" :items="listaEstado" item-text="nombre_estado"
                                    item-value="id_estado" outlined dense />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12">
                                <v-expansion-panels v-model="tab">
                                    <v-expansion-panel>
                                        <v-expansion-panel-header v-html="'Documento'"></v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-card flat>
                                                <v-card-text>
                                                    <ckeditor v-model="objetoCondicion.documento" :config="ckeditorConf" :editor-url="ckeditorUrl" :rules="requeridoRegla"></ckeditor>
                                                </v-card-text>
                                            </v-card>                                            
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="text-right mt-3 mb-3">
                                <v-btn outlined rounded color="danger" class="mr-1" @click="cerrarFormulario(), $refs.form.resetValidation()" :disabled="disabled">Cancelar</v-btn>
                                <v-btn rounded dark color="primary" @click="guardar()" :disabled="disabled">Guardar</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data: () => ({
            tab: 0,
            disabled: false,
            objDate: {
                abrirDialogo: false
            },
            checkBoxV: false,
            date: new Date().toISOString().substr(0, 10),
            menu: false,
            editorId: 'idEditor',
            editor: null,
            ancho: '100%',
            anchoSeguro: '100%',
            objetoCondicion: {},
            ckeditorConf:{ language: 'es', versionCheck: false },
            ckeditorUrl: 'https://cdn.ckeditor.com/4.22.1/standard-all/ckeditor.js',
        }),
        watch: {
            seleccionado() {
                this.visibilidadCheckBOx();
            },
            cargar() {
                this.disabled = false;
                if(!_.isUndefined(this.$refs.form))
                    this.$refs.form.resetValidation();

                if (this.cargar) {
                    this.objetoCondicion = _.clone(this.seleccionado);
                    this.objetoCondicion.fechaRegistroSCVS = !_.isUndefined(this.objetoCondicion.fechaRegistroSCVS) ? this.objetoCondicion.fechaRegistroSCVS : moment().format('YYYY-MM-DD');
                }
            }
        },
        methods: {
            visibilidadCheckBOx() {

                if (this.objetoCondicion.idTipoCondicion == this.lista.checkVehiculo.idTipoCondicion && this.objetoCondicion.idSeguro == this.lista.checkVehiculo.idSeguro) {
                    this.checkBoxV = true;
                    this.anchoSeguro = '50%'
                } else {
                    this.checkBoxV = false;
                    this.anchoSeguro = '100%';
                    this.objetoCondicion.vehiculoCredito = false
                }

            },
            guardar() {
                try {
                    if (!this.$refs.form.validate()) throw mensajeEstandar.corregirInformacion;
                    if (_.size(this.objetoCondicion.documento) == 0) throw "El documento no puede estar vacío";
                        this.disabled = true;
                        this.$parent.$parent.seleccionado = this.objetoCondicion;
                        this.insertarActualizar((this.objetoCondicion.idCondicionGeneral == null) ? "I" : 'U')
                            .then((r) =>{
                                if(_.get(r,['data','existeError'],true)) throw 'error';
                                    this.cerrarFormulario();
                                    this.$refs.form.resetValidation();
                            })
                            .catch((e)=>{
                                this.disabled = false;
                            });
                } catch (e) {
                    mensajesAlerta(e,"E")
                }
            },
            cambiarTam() {
                this.objetoCondicion.idCobertura = null;
                if (this.objetoCondicion.idTipoCondicion != this.lista.idLlevaCobertura) this.ancho = '100%';
                else this.ancho = '50%';
            }
        },
        props: ['seleccionado', 'tituloFormulario', 'lista', 'listaEstado', 'cargar'],
        inject: ['insertarActualizar', 'cerrarFormulario'],
    }
</script>